import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'spaces'] as const;

export const keys = {
  all,
  members: (spaceId: string) => [...all, 'members', spaceId] as const,
  detail: (spaceId: string) => [...all, 'detail', spaceId] as const,
  aiUsage: (spaceId: string) => [...all, 'aiUsage', spaceId] as const,
};
